<div class="spark-card" [class.selected]="selected">
  <div class="spark-section">
    <div class="new-bar" *ngIf="spark.isNew"></div>
    <div class="spark-inner">
      <div class="spark-header">
        <div class="spark-author">
          <app-user-avatar
            [userEmail]="spark.userEmail"
            [size]="32"
            class="spark-author-avatar"
          ></app-user-avatar>
          <div class="spark-author-text">
            <span class="spark-author-name">
              {{ (configService.userMap$ | async)?.[spark.userEmail] || spark.userEmail }}
            </span>
            <span class="spark-author-date" [attr.title]="spark.lastModifiedDate ? getLastEditedTooltip() : null">
              {{ spark.dateCreated | timeAgo }}<ng-container *ngIf="spark.lastModifiedDate">, <span i18n="@@lastEdited">last edited</span> {{spark.lastModifiedDate | timeAgo}} <span i18n="@@by">by</span> {{(configService.userMap$ | async)?.[spark.lastModifiedBy] || spark.lastModifiedBy}}</ng-container>
            </span>
          </div>
        </div>

        <div class="pinned-spark-actions">
          <app-spark-tags-overflow
            [tagIds]="spark.tags"
            [tags]="tags"
            [alignRight]="true"
          ></app-spark-tags-overflow>

          <div class="spark-actions">
            <app-svg-icon
              *ngIf="spark.hasImage"
              icon="image"
              [size]="24"
              color="var(--color-grey-500)"
            ></app-svg-icon>
            <app-svg-icon
              *ngIf="spark.hasAttachments"
              icon="attachment"
              [size]="24"
              color="var(--color-grey-500)"
            ></app-svg-icon>
          </div>

          <app-svg-icon
            *ngIf="spark.pinned"
            icon="pin"
            [size]="24"
            [strokeWidth]="1"
            color="var(--color-primary)"
            fill="var(--color-primary)"
          ></app-svg-icon>
          <div class="menu-container" [id]="'menu-' + spark.id">
            <app-svg-icon
              icon="more-horizontal"
              [size]="24"
              [strokeWidth]="3"
              color="var(--color-primary)"
              class="menu-icon"
            />

            <dx-context-menu
              [target]="'#menu-' + spark.id"
              showEvent="click"
              [items]="visibleMenuItems"
              cssClass="gpd-context-menu"
              (onItemClick)="onContextMenuItemClick($event)"
            ></dx-context-menu>
          </div>
        </div>
      </div>

      <div
        #sparkContentContainer
        class="spark-content"
        (click)="onContentClick($event)"
      >
        <div #safeContainer [innerHTML]="processedContent | safeHTML"></div>
      </div>
      <span
        *ngIf="(isContentTruncated || isContentExpanded) && !expanded"
        class="view-more-btn"
        (click)="toggleContent()"
        tabindex="0"
        role="button"
      >
        <span *ngIf="isContentExpanded" i18n="@@viewLess">View Less</span>
        <span *ngIf="!isContentExpanded" i18n="@@viewMore">View More</span>
      </span>

      <div class="spark-footer">
        <div class="spark-reactions">
          <app-svg-icon
            [id]="'likeIcon-' + spark.id"
            icon="thumbs-up"
            [size]="24"
            [strokeWidth]="2"
            color="var(--color-primary)"
            [fill]="spark.liked ? 'var(--color-primary)' : 'transparent'"
            (click)="toggleLike()"
            style="cursor: pointer"
          ></app-svg-icon>

          <dx-popover
            *ngIf="spark.likedByUsers && spark.likedByUsers.length > 0"
            [target]="'#likeIcon-' + spark.id"
            showEvent="mouseenter"
            hideEvent="mouseleave"
            [wrapperAttr]="{ class: 'gpd-popover' }"
            position="bottom"
            (onHiding)="onHidingLikePopover($event)"
            (onShowing)="showAllLikedUsers = false"
          >
            <div class="user-list">
              <div class="user-item" *ngFor="let user of displayedLikedUsers">
                <app-user-avatar
                  [userEmail]="user"
                  [size]="24"
                  class="user-avatar"
                ></app-user-avatar>
                <span class="user-name">{{ (configService.userMap$ | async)?.[user] || user }}</span>
              </div>
              <dx-button
                *ngIf="!showAllLikedUsers && spark.likedByUsers.length > 3"
                (onClick)="showAllLikedUsers = true"
                i18n-text="@@showAll"
                text="Show all ({{ spark.likedByUsers.length }})"
                style="margin-top:8px; width:100%; background:var(--color-primary); color:#fff; border:none; border-radius:4px; padding:4px 0; cursor:pointer; font-size:13px;"
              >
              </dx-button>
            </div>
          </dx-popover>
          
          <span class="spark-reaction-count" *ngIf="spark.likeCount > 0">{{
            spark.likeCount
          }}</span>
          <app-emoji-picker
            (emojiSelected)="onReactionClick($event)"
            [selectedEmoji]="selectedReaction"
          ></app-emoji-picker>
          <div
            class="reaction-list"
            *ngIf="spark.reactions && reactionEntries.length > 0"
          >
            <div
              [id]="safeEmojiId(reactionEntry.emoji)"
              class="reaction-item"
              *ngFor="let reactionEntry of reactionEntries"
            >
              <ngx-emoji
                class="reaction-emoji"
                [emoji]="reactionEntry.emoji"
                [style.height.px]="24"
                [size]="24"
              ></ngx-emoji>
              <span class="reaction-count">{{
                reactionEntry.users.length
              }}</span>

              <dx-popover
                [target]="'#' + safeEmojiId(reactionEntry.emoji)"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                [wrapperAttr]="{ class: 'gpd-popover' }"
                position="bottom"
              >
                <div class="user-list">
                  <div
                    class="user-item"
                    *ngFor="let user of reactionEntry.users"
                  >
                    <app-user-avatar
                      [userEmail]="user"
                      [size]="24"
                      class="user-avatar"
                    ></app-user-avatar>
                    <span class="user-name">{{
                      (configService.userMap$ | async)?.[user] || user
                    }}</span>
                  </div>
                </div>
              </dx-popover>
            </div>
          </div>

          <div class="spark-answer-text" (click)="toggleAnswerSection()">
            <span i18n="@@answer">Answer</span> {{ spark.answerCount }}
            <span i18n="@@reply">Reply</span>
            <app-svg-icon
              icon="chevron-down"
              [size]="12"
              [strokeWidth]="1"
              [class.rotated]="isAnswerSectionOpen"
            ></app-svg-icon>
          </div>
        </div>
      </div>

      <div class="answer-section" *ngIf="isAnswerSectionOpen">
        <div class="answer-input-wrapper">
          <app-answer-editor
            #newAnswerEditor
            placeholder="Write an answer..."
            i18n-placeholder="@@writeAnswer"
            [autofocus]="true"
            [disabled]="isSubmittingAnswer"
            (submitted)="submitAnswer($event)"
          ></app-answer-editor>
        </div>
        <div
          class="answer-separator"
          *ngIf="answers.length > 0 || isLoadingAnswers"
        ></div>

        <div class="answers-loading" *ngIf="isLoadingAnswers">
          <div class="loading-spinner" i18n="@@loadingAnswers">
            Loading answers...
          </div>
        </div>
        <div
          class="answers-list"
          *ngIf="answers.length > 0 && !isLoadingAnswers"
        >
          <app-answer-card
            *ngFor="let answer of answers"
            [answer]="answer"
            (onEdit)="handleAnswerEdit($event)"
            (onUpdate)="handleAnswerUpdate($event)"
            (onDelete)="handleAnswerDelete($event)"
          ></app-answer-card>
        </div>

        <div
          class="no-answers"
          *ngIf="
            answers.length === 0 && !isLoadingAnswers && isAnswerSectionOpen
          "
        >
          <p i18n="@@noAnswersYet">No answers yet. Be the first to answer!</p>
        </div>
      </div>
    </div>
  </div>
</div>
